import { SVGProps } from 'react';

export default function FooterLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" transform="matrix(-1 0 0 1 40 0)" fill="#E1F0E6"/>
    <path d="M19.9998 10C14.4771 10 10 14.4936 10 20.0367C10 24.7436 13.2287 28.6932 17.5842 29.778V23.104H15.5223V20.0367H17.5842V18.7151C17.5842 15.299 19.1246 13.7156 22.4662 13.7156C23.0997 13.7156 24.1929 13.8405 24.6401 13.9649V16.7451C24.4041 16.7202 23.9941 16.7078 23.4849 16.7078C21.8454 16.7078 21.2118 17.3312 21.2118 18.952V20.0367H24.4781L23.9169 23.104H21.2118V30C26.1633 29.3998 30 25.1683 30 20.0367C29.9996 14.4936 25.5225 10 19.9998 10Z" fill="#213735"/>
    </svg>

  );
} 
